import { defineSlotRecipe } from '@chakra-ui/react';

export const breadcrumbSlotRecipe = defineSlotRecipe({
  className: 'chakra-breadcrumb',
  slots: ['link', 'currentLink', 'item', 'list', 'root', 'ellipsis', 'separator'],
  base: {
    list: {
      display: 'flex',
      alignItems: 'center',
      wordBreak: 'break-word',
      color: 'fg.muted',
      listStyle: 'none',
    },
    link: {
      outline: '0',
      textDecoration: 'none',
      borderRadius: 'l1',
      focusRing: 'outside',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '2',
    },
    item: {
      display: 'grid',
      alignItems: 'center',
    },
    separator: {
      color: 'fg.muted',
      opacity: '0.8',
      _icon: {
        boxSize: '1em',
      },
      _rtl: {
        rotate: '180deg',
      },
    },
    ellipsis: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      _icon: {
        boxSize: '1em',
      },
    },
  },
  variants: {
    variant: {
      // underline: {
      //   link: {
      //     color: 'colorPalette.fg',
      //     textDecoration: 'underline',
      //     textUnderlineOffset: '0.2em',
      //     textDecorationColor: 'colorPalette.muted',
      //   },
      //   currentLink: {
      //     color: 'primary.dark',
      //   },
      // },
      plain: {
        list: {
          // flexWrap: 'nowrap',
          wordBreak: 'keep-all',
          whiteSpace: 'nowrap',
        },
        link: {
          color: 'primary.dark',
          textDecoration: 'none',
          textUnderlineOffset: '0.2em',
          textDecorationThickness: '0px',
          transitionProperty: 'text-decoration, text-decoration-thickness',
          transitionDuration: 'moderate',
          _hover: {
            textDecorationThickness: '2px',
            textDecoration: 'underline',
          },
          _focus: {
            outline: 'none',
          },
        },
        currentLink: {
          color: 'primary.dark',
          fontWeight: 'bold',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 'full',
        },
        separator: {
          color: 'primary.dark',
        },
        ellipsis: {
          color: 'primary.dark',
          bgColor: 'primary.light/50',
          borderRadius: 'full',
          p: 1,
        },
      },
    },
    size: {
      sm: {
        list: {
          gap: '1',
          textStyle: 'xs',
        },
      },
      md: {
        list: {
          gap: '1.5',
          textStyle: 'sm',
        },
      },
      lg: {
        list: {
          gap: '2',
          textStyle: 'md',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'plain',
    size: 'md',
  },
});
